import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

const UtiPanCardService = () => {
  // Features data
  const features = [
    {
      icon: "⚡",
      title: "Quick Application",
      description:
        "Submit PAN applications instantly through our platform. Get immediate acknowledgment.",
    },
    {
      icon: "📄",
      title: "e-PAN Delivery",
      description:
        "Customers receive e-PAN via email within minutes of issuance. Physical card dispatched to address.",
    },
    {
      icon: "🔍",
      title: "Real-Time Tracking",
      description:
        "Track application status in real-time – from submission to dispatch.",
    },
    {
      icon: "📱",
      title: "Mobile-Friendly",
      description:
        "Easy application process on mobile – perfect for agents serving customers on the go.",
    },
    {
      icon: "💰",
      title: "Attractive Commissions",
      description:
        "Earn Attractive commission per PAN application. Transparent and instant commission credited.",
    },
    {
      icon: "🛡️",
      title: "Secure & Compliant",
      description:
        "Fully compliant with Offline PAN Card guidelines. Secure data handling and encryption.",
    },
  ];

  // Service types (what you can do)
  const services = [
    { name: "New PAN Card Application", icon: "🆕" },
    { name: "Reprint of PAN Card", icon: "🖨️" },
    { name: "Changes / Correction in PAN", icon: "✏️" },
    { name: "PAN & Aadhaar Linking", icon: "🔗" },
    { name: "e-PAN Download", icon: "📥" },
  ];

  return (
    <React.Fragment>
      <Header variant="light" />
      <div className="service-page uti-page">
        <Helmet>
          <title>Offline PAN Card Service - Panmitra Online Services</title>
          <meta
            name="description"
            content="Apply for Offline PAN card online through Panmitra. Instant e-PAN, real-time tracking, and high commissions for agents. Authorized partner."
          />
        </Helmet>

        <div className="body-overlay"></div>

        <main>
          {/*===== HERO AREA STARTS =======*/}
          <div
            className="about-header-area"
            style={{
              backgroundImage: "url(assets/img/bg/inner-header.png)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-7 m-auto">
                  <div className="about-inner-header heading9 text-center">
                    <h1>Offline PAN Card Service</h1>
                    <a href="/">
                      Home <i className="fa-solid fa-angle-right" />{" "}
                      <span>Offline PAN Card Service</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/*===== SERVICE OVERVIEW =====*/}
          <section className="service-overview sp1">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="overview-content heading2">
                    <h5>Offline PAN Services</h5>
                    <h2>Become Offline PAN Card Agent</h2>
                    <p>
                      Panmitra offers seamless Offline PAN card services for
                      agents, distributors. Whether it's a new PAN application,
                      reprint, or correction, our platform ensures quick
                      submission and real‑time tracking. With direct UTI
                      integration, you can serve your customers with confidence
                      and earn attractive commissions.
                    </p>
                    <ul className="feature-list">
                      <li>
                        <i className="fa-solid fa-circle-check text-primary"></i>{" "}
                        Authorized Offline PAN Card facilitator
                      </li>
                      <li>
                        <i className="fa-solid fa-circle-check text-primary"></i>{" "}
                        Instant acknowledgment
                      </li>
                      <li>
                        <i className="fa-solid fa-circle-check text-primary"></i>{" "}
                        Realtime PAN Coupon Purchase
                      </li>
                      <li>
                        <i className="fa-solid fa-circle-check text-primary"></i>{" "}
                        24x7 customer support
                      </li>
                    </ul>
                    <div className="btn-area mt-4">
                      <a href="/contact-us" className="header-btn11">
                        Become PAN Agent
                        <i className="fa-solid fa-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="overview-image text-center">
                    <img
                      src="/images/pan-banner-2.jpg"
                      alt="Offline PAN Card Illustration"
                      className="img-fluid rounded-4 shadow"
                      onError={(e) => (e.target.style.display = "none")}
                    />
                    {/* <div
                      className="fallback-icon"
                      style={{ fontSize: "10rem", color: "#dee2e6" }}
                    >
                      <i className="fa-solid fa-id-card"></i>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/*===== KEY FEATURES =====*/}
          <section className="features-grid sp2 bg2">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 m-auto text-center">
                  <div className="heading2">
                    <h5>Why Agents Love Panmitra</h5>
                    <h2>Powerful Features for PAN Card Services</h2>
                    <p>
                      Everything you need to offer PAN services efficiently.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row g-4 mt-4">
                {features.map((feature, idx) => (
                  <div key={idx} className="col-lg-4 col-md-6">
                    <div className="feature-card">
                      <div className="feature-icon">{feature.icon}</div>
                      <h3>{feature.title}</h3>
                      <p>{feature.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/*===== SERVICE TYPES =====*/}
          <section className="service-types sp1">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 m-auto text-center">
                  <div className="heading2">
                    <h5>What We Offer</h5>
                    <h2>Complete PAN Card Solutions</h2>
                    <p>
                      From new applications to corrections – we've got you
                      covered.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row g-3 mt-4 justify-content-center">
                {services.map((item, idx) => (
                  <div key={idx} className="col-lg-4 col-md-6">
                    <div className="type-card">
                      <span className="type-icon">{item.icon}</span>
                      <span className="type-name">{item.name}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/*===== HOW IT WORKS =====*/}
          <section className="how-it-works sp2 bg2">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 m-auto text-center">
                  <div className="heading2">
                    <h5>Simple Process</h5>
                    <h2>How to Apply for PAN</h2>
                    <p>Three easy steps for agents to serve customers</p>
                  </div>
                </div>
              </div>
              <div className="row mt-5">
                <div className="col-md-4">
                  <div className="step-card">
                    <div className="step-number">1</div>
                    <h4>Collect Details</h4>
                    <p>
                      Gather customer's personal info, documents (Aadhaar,
                      address proof) and choose service type.
                    </p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="step-card">
                    <div className="step-number">2</div>
                    <h4>Submit Application</h4>
                    <p>
                      Enter details in Panmitra portal. Get instant
                      acknowledgment and track status.
                    </p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="step-card">
                    <div className="step-number">3</div>
                    <h4>Deliver PAN</h4>
                    <p>
                      Once issued, e-PAN is sent to customer. Physical card is
                      dispatched by UTI.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/*===== CTA SECTION =====*/}
          <section
            className="cta5-section-area sp1"
            style={{
              backgroundImage: "url(assets/img/bg/header-bg5.png)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-8 m-auto text-center">
                  <div className="cta-content heading2">
                    <h2 className="text-white">Ready to offer PAN services?</h2>
                    <p className="text-white">
                      Join Panmitra today and start earning with every PAN
                      application.
                    </p>
                    <div className="btn-area mt-4 d-flex justify-content-center flex-wrap gap-3">
                      <a href="/contact-us" className="header-btn11">
                        Become an Agent{" "}
                        <i className="fa-solid fa-arrow-right"></i>
                      </a>
                      <a
                        href="https://developers.instantpanmitra.com"
                        target="_blank"
                        className="header-btn10 text-white"
                      >
                        Explore APIs <i className="fa-solid fa-arrow-right" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
      <Footer hideCTA={true} />

      {/* Embedded CSS (same as other service pages) */}
      <style>{`
        .service-page {
          overflow-x: hidden;
        }
        .service-overview {
          background-color: #fff;
        }
        .overview-content .feature-list {
          list-style: none;
          padding: 0;
          margin: 20px 0 0;
        }
        .overview-content .feature-list li {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 10px;
          font-size: 1rem;
          color: #334155;
        }
        .overview-content .feature-list i {
          color: #10b981;
          font-size: 1.3rem;
        }
        .features-grid {
          background-color: #f9fafc;
        }
        .feature-card {
          background: #fff;
          border-radius: 20px;
          padding: 30px 25px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.05);
          transition: transform 0.3s ease;
          height: 100%;
          text-align: center;
        }
        .feature-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.1);
        }
        .feature-icon {
          font-size: 3rem;
          margin-bottom: 20px;
        }
        .feature-card h3 {
          font-size: 1.4rem;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 15px;
        }
        .feature-card p {
          color: #4b5563;
          line-height: 1.6;
        }
        .type-card {
          background: #fff;
          border-radius: 16px;
          padding: 20px 15px;
          text-align: center;
          box-shadow: 0 5px 15px rgba(0,0,0,0.05);
          transition: all 0.2s ease;
          border: 1px solid #eef2f6;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
        }
        .type-card:hover {
          border-color: #f39c12;
          box-shadow: 0 8px 20px rgba(243,156,18,0.1);
        }
        .type-icon {
          font-size: 2.5rem;
        }
        .type-name {
          font-weight: 600;
          color: #1e293b;
          font-size: 1.1rem;
        }
        .step-card {
          text-align: center;
          padding: 30px 20px;
          background: #fff;
          border-radius: 20px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.05);
          height: 100%;
        }
        .step-number {
          width: 60px;
          height: 60px;
          background: #f39c12;
          color: #fff;
          font-size: 2rem;
          font-weight: 700;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 20px;
        }
        .step-card h4 {
          font-size: 1.3rem;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 15px;
        }
        .step-card p {
          color: #4b5563;
          line-height: 1.6;
        }
        .service-cta {
          background-color: #f8fafc;
          border-radius: 40px 40px 0 0;
        }
        .fallback-icon {
          opacity: 0.3;
        }
        .btn-area .header-btn10 {
          background: transparent;
          border: 2px solid #f39c12;
          color: #1e293b;
          padding: 12px 30px;
          border-radius: 50px;
          font-weight: 600;
          transition: all 0.3s ease;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }
        .btn-area .header-btn10:hover {
          background: #f39c12;
          color: #fff;
        }
        @media (max-width: 768px) {
          .feature-card, .step-card, .type-card {
            padding: 20px;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export default UtiPanCardService;
